import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setPersonalInfo} from '../actions'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function PersonalInfo() {
  const {name:resumeName,designation:resumeDesignation, address:resumeAddress, email:resumeEmail, contact:resumeContact}=useSelector(states=>states.resumeData)
  const history = useHistory();
  const dispatch=useDispatch()
  const [name,setName]=useState(resumeName)
  const [designation,setDesignation]=useState(resumeDesignation)
  const [address,setAddress]=useState(resumeAddress)
  const [email,setEmail]=useState(resumeEmail)
  const [contact,setContact]=useState(resumeContact)
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setPersonalInfo({
      name:name,
      designation:designation,
      address:address,
      email:email,
      contact:contact
    }))
    history.push("/education-details");
  }
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i class="mr-2 fas fa-user"></i>Personal Info</h1>
        <form onSubmit={handleSubmit}>
          <input type="text" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Your name" required />
          <input
            type="text"
            value={designation}
            onChange={(e)=>setDesignation(e.target.value)} 
            placeholder="Designation"
            required
          />
          <input type="text" value={address} onChange={(e)=>setAddress(e.target.value)} placeholder="Address" required />
          <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" required />
          <input type="tel" value={contact} onChange={(e)=>setContact(e.target.value)} placeholder="Contact" required />
          <motion.button variants={linkVariant} whileHover="hover" type="submit">next</motion.button>
        </form>
      </motion.div>
    </motion.div>
  );
}
